export * from './AdditionalNotesLineItemDetail';
export * from './DetailLineItem';
export * from './DetailType';
export * from './FecalLineItemDetail';
export * from './FeedingLineItemDetail';
export * from './FoodSize';
export * from './FoodType';
export * from './GrowthLineItemDetail';
export * from './HealthLineItemDetail';
export * from './InventoryMasterDetail';
export * from './NewUser';
export * from './ShedLineItemDetail';
export * from './UserGroup';
export * from './UserProfile';
export * from './ViewDetailLineItem';
export * from './ViewMasterDetailWithImage';
export * from './ViewUserModel';
export * from './ViewFoodTypeCountsModel';
export * from './ViewRefusalCountSinceLastConsumptionModel';


// WEBPACK FOOTER //
// ./src/app/models/index.ts